import { tsrContractsClient } from '../tsrContractsClient';

export const patientNotesClient = () => tsrContractsClient.patientNotesContract;
